export default __webpack_public_path__ + "static/media/road_bike.65bc86eb.jpg";